var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"in-trial-course-timer",on:{"click":_setup.shopifyCheckout}},[_c('h5',[_vm._v(_vm._s(_setup.daysLeftText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }